import React, { useState } from 'react';
import classnames from 'classnames';
import storage from '$lib/storage';
import styles from './styles.scss';

const Impersonated = (props) => {
  const { currentUser } = props;
  const [isTop, setTop] = useState(false);
  const { isImpersonated, email } = storage.getAuth();

  if (!isImpersonated) {
    return null;
  }

  const { uuid } = currentUser;

  return (
    <div
      className={classnames(
        styles.impersonateOverlay,
        isTop ? styles.positionTop : styles.positionBottom
      )}
    >
      <button className={styles.toggleOverlayButton} onClick={() => setTop(!isTop)}>
        <i className={classnames('fad', isTop ? 'fa-arrow-down' : 'fad fa-arrow-up')} />
      </button>

      <span className={styles.viewingAs}>
        Viewing as:&nbsp;
        {email} - {uuid}
      </span>

      <a href="/auth/sign-out">
        <i className="fad fa-sign-out-alt" />
      </a>
    </div>
  );
};

export default Impersonated;
